module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('Panel', {
    staticClass: "panel-border"
  }, [_vm._c('PanelHeading', [_vm._c('div', {
    slot: "title"
  }, [(_vm.editingTitle) ? _vm._c('form', {
    staticStyle: {
      "max-width": "250px"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.finishEditingTitle($event)
      }
    }
  }, [_vm._c('div', {
    staticClass: "input-group input-group-sm"
  }, [_vm._c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newTitle),
      expression: "newTitle"
    }, {
      name: "focus",
      rawName: "v-focus"
    }, {
      name: "on-click-away",
      rawName: "v-on-click-away",
      value: (_vm.cancelEditingTitle),
      expression: "cancelEditingTitle"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.newTitle)
    },
    on: {
      "keyup": function($event) {
        if (_vm._k($event.keyCode, "esc", 27)) { return; }
        _vm.cancelEditingTitle($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newTitle = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._c('span', {
    staticClass: "input-group-btn"
  }, [_vm._c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Save")])])])]) : _vm._c('div', [_vm._c('span', {
    on: {
      "dblclick": _vm.startEditingTitle
    }
  }, [_vm._v(_vm._s(_vm.subject.title))]), _vm._v(" "), _vm._c('span', {
    staticClass: "expandButton",
    on: {
      "click": _vm.toggleExpanded
    }
  }, [(_vm.expanded) ? _vm._c('span', {
    staticClass: "icon mdi mdi-chevron-down"
  }) : _vm._c('span', {
    staticClass: "icon mdi mdi-chevron-right"
  })]), _vm._v(" "), _vm._c('span', {
    staticClass: "panel-subtitle"
  }, [_vm._v(_vm._s(((_vm.chapters.length) + " Chapter" + (_vm.chapters.length === 1 ? '' : 's'))))])])])]), _vm._v(" "), (_vm.expanded) ? _vm._c('PanelBody', [(!_vm.chapters.length) ? _vm._c('div', [_vm._c('p', [_vm._c('em', [_vm._v("This subject is empty.")])]), _vm._v(" "), (_vm.showActions) ? _vm._c('p', [_vm._c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.deleteSubject(_vm.subject)
      }
    }
  }, [_vm._v("Delete subject")])]) : _vm._e()]) : _vm._c('div', [_vm._c('table', {
    staticClass: "table"
  }, [_vm._c('thead', [_vm._c('tr', [_vm._c('th', {
    staticClass: "hidden-xs",
    staticStyle: {
      "width": "5%"
    }
  }), _vm._v(" "), _vm._c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("Chapter")]), _vm._v(" "), _vm._c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("Study Progress")]), _vm._v(" "), _vm._c('th', {
    staticClass: "hidden-xs",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _vm._c('th', {
    staticClass: "hidden-xs",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Last Studied")]), _vm._v(" "), _vm._c('th', {
    staticStyle: {
      "width": "20%"
    }
  })])]), _vm._v(" "), _vm._c('tbody', _vm._l((_vm.chapters), function(chapter) {
    return _vm._c('SubjectShelfChapterRow', {
      attrs: {
        "chapter": chapter
      }
    })
  }))])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f137b702!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/subject-shelf/SubjectShelfSubject.vue
// module id = 720
// module chunks = 1